import React, { ReactElement, useEffect } from 'react'
import {
	CopyrightAgentLoader,
	PrimaryButton,
	Row,
	SearchInput,
	TextLabel,
	Typography,
} from '@copyrightagent/basic-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import globalUseStyle from '../style'
import { UploadCertificateModal } from './UploadCertificateModal'
import clsx from 'clsx'
import { useRegistrationCertificatesStore } from '../stores/registrationCertificateStore'
import { RouteComponentProps } from 'react-router'
import { useRegisteredImagesStore } from '../stores/registeredImagesStore'
import Response from 'lib/http/Response'

const RegistrationCertificatesList = (
	props: RouteComponentProps,
): ReactElement => {
	const {
		hasRegistrationCertificatesInitiallyLoaded,
		fetchRegistrationCertificates,
		registrationCertificates,
		totalRegistrationCertificatesCount,
		setSearchString,
		searchString,
		setUploadCertificateModalOpen,
	} = useRegistrationCertificatesStore()
	const { selectedRegistrationCertificate } = useRegisteredImagesStore()
	const globalClasses = globalUseStyle()

	useEffect(() => {
		fetchRegistrationCertificates({
			isInitialLoad: true,
		})
	}, [])

	const handleSearch = async () => {
		fetchRegistrationCertificates({
			isInitialLoad: true,
		})
	}

	const selectCertificate = (registrationCertificateId: string) => {
		props.history.push(
			`/registration-certificates/${registrationCertificateId}`,
		)
	}

	return (
		<div className={globalClasses.subPageContainer}>
			<div className={globalClasses.titleContainer}>
				<div>
					<Typography variant="body2" className={globalClasses.listTitle}>
						Registration Certificates
					</Typography>
					<Typography variant="body2" fontColor="rgb(142, 147, 155)">
						{totalRegistrationCertificatesCount} registration certificates
					</Typography>
				</div>
				<PrimaryButton
					text={'Upload Certificate'}
					onClick={() => setUploadCertificateModalOpen(true)}
				/>
			</div>
			<div className={globalClasses.searchContainer}>
				<SearchInput
					value={searchString}
					onChange={(e) => setSearchString(e.target.value)}
					placeholder={'Search for Registration Certificate'}
				/>
				<PrimaryButton
					style={{ marginLeft: '16px' }}
					text={'Search'}
					onClick={handleSearch}
				/>
			</div>
			<div
				id="registrationCertificatesList"
				className={globalClasses.listContainer}
				style={{ height: 'calc(100vh - 292px)' }}
			>
				{hasRegistrationCertificatesInitiallyLoaded ? (
					registrationCertificates.length > 0 ? (
						<InfiniteScroll
							className={globalClasses.infiniteScrollWrap}
							dataLength={registrationCertificates.length}
							next={fetchRegistrationCertificates}
							hasMore={
								registrationCertificates.length <
								totalRegistrationCertificatesCount
							}
							loader={
								<div key={0} className={globalClasses.loadingContainer}>
									<CopyrightAgentLoader />
								</div>
							}
							scrollableTarget="registrationCertificatesList"
						>
							{registrationCertificates.map(
								(registrationCertificate, index) => (
									<Row justify="flex-start" key={index}>
										<div
											className={clsx(
												globalClasses.card,
												selectedRegistrationCertificate?.registration_certificate_id ===
													registrationCertificate.registration_certificate_id &&
													globalClasses.selectedCard,
											)}
											onClick={() =>
												selectCertificate(
													registrationCertificate.registration_certificate_id,
												)
											}
											style={{ display: 'flex' }}
										>
											<div
												className={globalClasses.containerWithChip}
												style={{ width: '200px' }}
											>
												<div>
													<Typography variant="body2">
														{
															registrationCertificate.registration_certificate_number
														}
													</Typography>
												</div>
											</div>
											<div className={globalClasses.rowDivider} />
											<div
												className={globalClasses.containerWithChip}
												style={{ width: '220px' }}
											>
												<div>
													<Typography variant="body2">
														{registrationCertificate.registered_image_count}{' '}
														images
													</Typography>
												</div>
												{registrationCertificate.registered_image_count ===
													0 && (
													<TextLabel
														uppercase
														size="small"
														labelText={'Missing images'}
														color={'yellow'}
													/>
												)}
											</div>
											<div className={globalClasses.rowDivider} />
											<div className={globalClasses.containerWithChip}>
												<div>
													<Typography
														variant="body2"
														fontColor="rgb(142, 147, 155)"
													>
														Effective Date
													</Typography>
													<Typography variant="body2">
														{
															registrationCertificate.effective_registration_date
														}
													</Typography>
												</div>
											</div>
										</div>
									</Row>
								),
							)}
						</InfiniteScroll>
					) : (
						<div className={globalClasses.loadingContainer}>
							<Typography variant="body2" fontColor="rgb(142, 147, 155)">
								No certificates found.
							</Typography>
						</div>
					)
				) : (
					<div className={globalClasses.loadingContainer}>
						<CopyrightAgentLoader />
					</div>
				)}
			</div>
			<UploadCertificateModal
				uploadSuccessCallback={(response: Response) => {
					props.history.push(
						`/registration-certificates/${response.data.registration_certificate_id}`,
					)
				}}
			/>
		</div>
	)
}

export default RegistrationCertificatesList
